import React, { ReactElement, useContext } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import Context from '../../context';

interface IProps {
  children: ReactElement;
  hideTooltip?: boolean;
  editableChildren?: boolean;
}

export default function SuperAdminPermission(props: IProps) {
  const { children, hideTooltip, editableChildren } = props;
  const { t } = useTranslation();
  const { isSuperAdmin } = useContext(Context);
  if (!isSuperAdmin) return null;

  if (hideTooltip) return children;

  let title = t('only_super_admin_will_see_this');

  if (editableChildren) {
    title = t('only_super_admin_editable');
  }

  return <Tooltip title={title}>{children}</Tooltip>;
}
